var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.429,
    height: 22.429,
    viewBox: "0 0 27.429 27.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-2.946 -2.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21369",
    "data-name": "Trazado 21369",
    d: "M30.375,28.941l-7.662-7.662a11.178,11.178,0,1,0-1.435,1.435l7.662,7.662ZM5.012,14.143a9.131,9.131,0,1,1,9.131,9.131,9.131,9.131,0,0,1-9.131-9.131Z",
    transform: "translate(0 0)",
    fill: "#094e80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlue);
export default __webpack_public_path__ + "bill-reader/static/media/search-icon-blue.cc010afd4347323699efe57cb519d7ea.svg";
export { ForwardRef as ReactComponent };